// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".funnel-url[data-v-02677941]{word-break:break-all}.funnel-url span[data-v-02677941]{color:var(--stan-primary-primary-color)}", "",{"version":3,"sources":["webpack://src/components/modals/EditFunnelDetailsModal.vue"],"names":[],"mappings":"AAAA,6BAA6B,oBAAoB,CAAC,kCAAkC,uCAAuC","sourcesContent":[".funnel-url[data-v-02677941]{word-break:break-all}.funnel-url span[data-v-02677941]{color:var(--stan-primary-primary-color)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
